module.exports = __webpack_public_path__ + "assets/SumSquares.faa1209bc85f8feb7deffff99b8b780b.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/SumSquares.gmt
// module id = 1004
// module chunks = 0